export class ConnectionInfo {
    ResourceType: string;
    ResourceName: string;
}